/**
 * @deprecated 不要在这里维护账号类型，应该使用后台协议中定义的枚举值
 * import type { docx } from '@tencent/tdocs-shared-proto/lib/3rd/oidb/user/data/online_docs_user_data';
 * export type ACCOUNT_TYPE = docx.backend.common.proto.third.oidb.user.data.UID_SOURCE;
 * 登录类型
 */
export var ACCOUNT_TYPE = /*#__PURE__*/function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE[ACCOUNT_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QQ"] = 1] = "QQ";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WX"] = 2] = "WX";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK"] = 3] = "WORK";
  ACCOUNT_TYPE[ACCOUNT_TYPE["EMAIL"] = 4] = "EMAIL";
  ACCOUNT_TYPE[ACCOUNT_TYPE["PHONE"] = 8] = "PHONE";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK_COMBINATION"] = 9] = "WORK_COMBINATION";
  ACCOUNT_TYPE[ACCOUNT_TYPE["TOWER"] = 10] = "TOWER";
  ACCOUNT_TYPE[ACCOUNT_TYPE["ROBOT"] = 11] = "ROBOT";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QFYF"] = 12] = "QFYF";
  ACCOUNT_TYPE[ACCOUNT_TYPE["OPEN"] = 13] = "OPEN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["MEETING"] = 14] = "MEETING";
  return ACCOUNT_TYPE;
}({});
export var LOGINTYPE = /*#__PURE__*/function (LOGINTYPE) {
  LOGINTYPE[LOGINTYPE["UNKNOWN"] = 0] = "UNKNOWN";
  LOGINTYPE[LOGINTYPE["WECHAT"] = 4] = "WECHAT";
  LOGINTYPE[LOGINTYPE["WEWORK"] = 3] = "WEWORK";
  return LOGINTYPE;
}({});

/**
 * Domain实体ID的类型
 */

/**
 * 类型合集
 */

/**
 * Window 作用域
 */

/**
 * 支持自定义范型的 Message 事件接口
 */

/**
 * 收藏文档时 取消 or 收藏 flag
 */
export var COLLECT_CANCEL_FLAG = {
  COLLECT: 0,
  CANCEL: 1
};
/**
 * 创建文档时 创建来源类型
 */
export var CREATE_SOURCE_TYPE = {
  BLANK: 1,
  TEMPLATE: 2,
  COPY: 4
};
/**
 * 创建文档时 文档类型
 */
export var CREATE_DOC_TYPE = {
  DOC: 0,
  EXCEL: 1,
  PPT: 2,
  FORM: 3
};
/**
 * 创建文档时 文档是否沉淀，
 */
export var CREATE_HUMTRANS_FALG = {
  NONE: 0,
  HUMTRANS: 1
};
/**
 * 列表页列表类型 待补充
 */
export var FOLDER_LIST_TYPE = {
  NONE: 0,
  DEFAULT: 5
};
/**
 * 获取模版recommend flag
 */
export var GET_RECOMMEND_FLAG = {
  MOBILE: 0,
  PC: 1
};
/**
 * 用户 VIP 信息
 */
export var EVipLevel = {
  Inactive: 1,
  NormalVip: 2,
  SuperVip: 3
};
/**
 * 自动续费状态
 */
export var ERenewalStatus = {
  Inactive: 0,
  Active: 1,
  CloseAfterActive: 2
};

/**
 * 通过 CGI 初始化领域服务时的参数
 */

/**
 * cgi请求统一的返回码retcode定义
 */
export var RETCODE = {
  SUCCESS: 0,
  NO_PERMISSION: 10003
};

/**
 * cgi请求返回的cgicode定义， 这里只包含成功部分，  其它cgi自己的业务的CgiCode可以定义在自己的业务请求类里。
 */
export var BASE_CGICODE = {
  SUCCESS: 0
};
//# sourceMappingURL=base.js.map